import { decodeJWTPayload } from './JWTUtils';

export type ResourceIdsType = {
  tenantResourceId: string;
  userResourceId: string;
};

const getResourceIds = (accessToken: string): ResourceIdsType => {
  const payload = decodeJWTPayload(accessToken);
  const externalUserRefIDs = payload?.externalUserRefIDs || [];
  const externalOrgRefIDs = payload?.externalOrgRefIDs || [];

  return {
    tenantResourceId:
      externalOrgRefIDs.find(
        (ref) => ref.type === 'EXTERNAL_ORG_IDENTIFIER_TYPE_STRATUS'
      )?.value || null,
    userResourceId:
      externalUserRefIDs.find(
        (ref) => ref.type === 'EXTERNAL_USER_IDENTIFIER_TYPE_STRATUS'
      )?.value || null
  };
};

export default getResourceIds;
